import { render, staticRenderFns } from "./NotRecordNameVoting.vue?vue&type=template&id=51d23276&scoped=true"
import script from "./NotRecordNameVoting.vue?vue&type=script&lang=js"
export * from "./NotRecordNameVoting.vue?vue&type=script&lang=js"
import style0 from "./NotRecordNameVoting.vue?vue&type=style&index=0&id=51d23276&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51d23276",
  null
  
)

export default component.exports